import React, { FC, useState } from 'react';
import { useQuery } from 'react-query';
import qs from 'query-string';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import MainLayout from 'components/main-layout/MainLayout';
import ReactTableWrapper from 'components/table/ReactTableWrapper';
import exampleEditorTemplates from 'utils/config/exampleEditorTemplates';
import API from 'core/Api';
import { IResponseData } from 'types/api';
import Form1 from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';
import { useForm } from 'react-hook-form';
import TextEditor from 'components/editor/TextEditor';
import PagePreview from 'components/editor/PagePreview';
import Button from 'components/Button';
import { useModal } from 'store/modal';
import { ISelectOptionProps } from 'components/form/types';
import { formatDate } from 'utils/helpers/formatters';

interface IInputs {
  firstName: string;
  lastName: string;
  customSelect: ISelectOptionProps[];
  customSelect1: ISelectOptionProps[];
  customSelect2: ISelectOptionProps[];
  customSelect3: ISelectOptionProps[];
  radioTest: string;
  checkboxTest: string[];
  switchTest: boolean;
  fileUploadTest: File[];
  textArea: string;
  datepicker1: Date;
  datepicker2: Date;
  datepicker3: Date;
  datepicker4: Date;
}

const HomeScreen: FC = () => {
  const { showModal } = useModal();
  const [editorContent, setEditorContent] = useState(
    "<p>test</p><img width='30' height='30' onclick='alert(`test sanitizing`);' />" +
      "<a href='javascript:alert(`test JS in href`);'>link</a>"
  );
  const [isEditMode, setIsEditMode] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);

  const fetchUsers = (): Promise<IResponseData<any>> => {
    const queryString = qs.stringify({
      offset,
      limit,
    });
    return API.get<IResponseData<any>>(`users?${queryString}`).then(res => {
      showModal({
        type: 'success',
        content: 'Users ready!',
      });

      const items = res.data.items.map((dataRow: any) => ({
        ...dataRow,
        name: `${dataRow.first_name} ${dataRow.last_name}`,
        status: dataRow.is_active ? 'Активен' : 'Неактивен',
      }));

      return {
        ...res.data,
        items,
      };
    });
  };

  const { isLoading, error, data } = useQuery<IResponseData<any>, Error>(
    ['users', offset, limit],
    (): Promise<IResponseData<any>> => {
      return fetchUsers();
    }
  );

  const methods = useForm<IInputs>({
    // Example for default values
    defaultValues: {
      firstName: 'Ivan',
      customSelect: [
        {
          label: 'Select2',
          value: 'select2',
        },
      ],
      customSelect2: [
        { value: 'ocean', label: 'Ocean' },
        { value: 'blue', label: 'Blue' },
        { value: 'purple', label: 'Purple' },
      ],
      checkboxTest: ['checkbox1', 'checkbox2'],
      radioTest: 'radio3',
      datepicker1: new Date(),
      datepicker2: new Date(),
      datepicker3: new Date(),
      datepicker4: new Date(),
    },
  });
  const onSubmit = (data1: IInputs): void => {
    const { datepicker1, datepicker2, datepicker3, datepicker4 } = data1;
  };

  return (
    <MainLayout
      title="Home"
      isLoading={isLoading}
      error={error}
    >
      <Row className="mb-4">
        <Col>
          <Button
            className="mb-3"
            onClick={() => setIsEditMode(!isEditMode)}
          >
            Toggle editor
          </Button>
          {isEditMode ? (
            <TextEditor
              name="test"
              content={editorContent}
              updateContent={setEditorContent}
              templates={exampleEditorTemplates}
            />
          ) : (
            <PagePreview
              content={editorContent}
              name="Test"
              number="00000001"
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          <Form1
            methods={methods}
            onSubmit={onSubmit}
            btnLabel="Запази"
            isHorizontal
          >
            <FormGroup
              controlId="formGroupFirstName"
              label="First Name"
              type="text"
              placeholder="Enter first name"
              name="firstName"
              isRequired
              isHorizontal
              hint="Hint ..."
              tooltip="Tooltip ..."
            />
            <FormGroup
              controlId="formGroupLastName"
              label="Last Name"
              type="text"
              placeholder="Enter last name"
              name="lastName"
              isRequired
              isHorizontal
              tooltip="Tooltip ..."
            />
            <hr />
            <FormGroup
              controlId="formGroupSelect"
              label="Single select"
              type="select"
              as="select"
              name="customSelect"
              isRequired
              isClearable
              isSearchable
              isHorizontal
              hint="Hint ... test"
              selectOptions={[
                {
                  label: 'Select1',
                  value: 'select1',
                },
                {
                  label: 'Select2',
                  value: 'select2',
                },
                {
                  label: 'Select3',
                  value: 'select3',
                },
                {
                  label: 'Select4',
                  value: 'select4',
                },
              ]}
            />
            <FormGroup
              controlId="formGroupSelect"
              label="Multi select"
              type="select"
              as="select"
              name="customSelect1"
              isRequired
              isClearable
              isSearchable
              isHorizontal
              isMulti
              allowSelectAll
              hint="Hint ... test"
              selectOptions={[
                {
                  label: 'Select1',
                  value: 'select1',
                },
                {
                  label: 'Select2',
                  value: 'select2',
                },
                {
                  label: 'Select3',
                  value: 'select3',
                },
                {
                  label: 'Select4',
                  value: 'select4',
                },
              ]}
            />
            <FormGroup
              controlId="formGroupSelect2"
              label="Multi select with grouped options without select all option"
              type="select"
              as="select"
              name="customSelect2"
              isRequired
              isClearable
              isSearchable
              isHorizontal
              isMulti
              hint="Hint ... test"
              selectOptions={[
                {
                  label: 'Colours',
                  options: [
                    { value: 'ocean', label: 'Ocean' },
                    { value: 'blue', label: 'Blue' },
                    { value: 'purple', label: 'Purple' },
                    { value: 'red', label: 'Red' },
                    { value: 'orange', label: 'Orange' },
                    { value: 'yellow', label: 'Yellow' },
                    { value: 'green', label: 'Green' },
                    { value: 'forest', label: 'Forest' },
                    { value: 'slate', label: 'Slate' },
                    { value: 'silver', label: 'Silver' },
                  ],
                },
                {
                  label: 'Flavours',
                  options: [
                    { value: 'vanilla', label: 'Vanilla' },
                    { value: 'chocolate', label: 'Chocolate' },
                    { value: 'strawberry', label: 'Strawberry' },
                    { value: 'salted-caramel', label: 'Salted Caramel' },
                  ],
                },
              ]}
            />
            <FormGroup
              controlId="formGroupSelect2"
              label="Multi select with grouped and normal options and show total"
              type="select"
              as="select"
              name="customSelect3"
              isRequired
              isClearable
              isSearchable
              isHorizontal
              isMulti
              showTotal
              allowSelectAll
              hint="Hint ... test"
              selectOptions={[
                { value: 'ocean1', label: 'Ocean1' },
                { value: 'ocean2', label: 'Ocean2' },
                {
                  label: 'Colours',
                  options: [
                    { value: 'ocean', label: 'Ocean' },
                    { value: 'blue', label: 'Blue' },
                    { value: 'purple', label: 'Purple' },
                    { value: 'red', label: 'Red' },
                    { value: 'orange', label: 'Orange' },
                    { value: 'yellow', label: 'Yellow' },
                    { value: 'green', label: 'Green' },
                    { value: 'forest', label: 'Forest' },
                    { value: 'slate', label: 'Slate' },
                    { value: 'silver', label: 'Silver' },
                  ],
                },
                {
                  label: 'Flavours',
                  options: [
                    { value: 'vanilla', label: 'Vanilla' },
                    { value: 'chocolate', label: 'Chocolate' },
                    { value: 'strawberry', label: 'Strawberry' },
                    { value: 'salted-caramel', label: 'Salted Caramel' },
                  ],
                },
              ]}
            />
            <hr />
            <FormGroup
              controlId="formGroupRadio"
              label="Radio"
              checkType="radio"
              name="radioTest"
              isRequired
              isHorizontal
              hint="Hint ... test"
              options={[
                {
                  label: 'Radio 1',
                  name: 'radioTest',
                  id: 'radio1',
                  value: 'radio1',
                },
                {
                  label: 'Radio 2',
                  name: 'radioTest',
                  id: 'radio2',
                  value: 'radio2',
                },
                {
                  label: 'Radio 3',
                  name: 'radioTest',
                  id: 'radio3',
                  value: 'radio3',
                },
              ]}
            />
            <FormGroup
              controlId="formGroupCheckbox"
              label="Checkbox"
              checkType="checkbox"
              name="checkboxTest"
              isRequired
              isHorizontal
              hint="Hint ... test"
              options={[
                {
                  label: 'Checkbox 1',
                  name: 'checkboxTest',
                  id: 'checkbox1',
                  value: 'checkbox1',
                },
                {
                  label: 'Checkbox 2',
                  name: 'checkboxTest',
                  id: 'checkbox2',
                  value: 'checkbox2',
                },
                {
                  label: 'Checkbox 3',
                  name: 'checkboxTest',
                  id: 'checkbox3',
                  value: 'checkbox3',
                },
              ]}
            />
            <FormGroup
              controlId="formGroupSwitch"
              label="Switch"
              checkType="switch"
              name="switchTest"
              isRequired
              isHorizontal
              hint="Hint ... test"
            />
            <hr />
            <FormGroup
              controlId="formGroupFileUpload"
              label="File upload"
              type="file"
              placeholder="Качете файловете тук или кликнете, за да изберете файл."
              name="fileUploadTest"
              isRequired
              isHorizontal
              accept="application/pdf"
              multiple
              hint="Позволени файлови разширения: pdf"
            />
            <hr />
            <FormGroup
              controlId="formGroupTextArea"
              label="TextArea"
              as="textarea"
              placeholder="Free text"
              name="textArea"
              isRequired
              isHorizontal
            />
            <FormGroup
              controlId="formGroupDate"
              label="Пълна дата с час"
              type="datepicker"
              name="datepicker1"
              showTimeSelect
              isRequired
              isHorizontal
              dateFormat="dd.MM.yyyy H:mm"
            />
            <FormGroup
              controlId="formGroupDate2"
              label="Пълна дата"
              type="datepicker"
              name="datepicker2"
              isRequired
              isHorizontal
              dateFormat="dd.MM.yyyy"
            />
            <FormGroup
              controlId="formGroupDate3"
              label="Ден и месец"
              type="datepicker"
              name="datepicker3"
              isRequired
              isHorizontal
              dateFormat="dd.MM."
            />
            <FormGroup
              controlId="formGroupDate4"
              label="Година"
              type="datepicker"
              name="datepicker4"
              showYearPicker
              isRequired
              isHorizontal
              dateFormat="yyyy"
            />
            <FormGroup
              controlId="formGroupEditor"
              label="Редактор"
              type="wysiwyg-editor"
              name="editor"
              isRequired
              isHorizontal
            />
          </Form1>

          {data && (
            <ReactTableWrapper<any>
              data={data.items}
              columns={[
                {
                  // Build our expander column
                  id: 'expander', // Make sure it has an ID
                  disableSortBy: true,
                  Cell: ({ row }) =>
                    // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
                    // to build the toggle for expanding a row
                    row.canExpand ? (
                      <span
                        {...row.getToggleRowExpandedProps({
                          style: {
                            // We can even use the row.depth property
                            // and paddingLeft to indicate the depth
                            // of the row
                            paddingLeft: `${row.depth * 2}rem`,
                          },
                        })}
                      />
                    ) : null,
                },
                {
                  Header: 'ID',
                  accessor: 'id',
                },
                {
                  Header: 'Име',
                  accessor: 'name',
                },
                {
                  Header: 'Email',
                  accessor: 'email',
                },
                {
                  Header: 'Статус',
                  accessor: 'status',
                },
              ]}
              pagination
              offset={offset}
              limit={limit}
              totalCount={data.totalCount}
              setOffset={setOffset}
              setLimit={setLimit}
            />
          )}
        </Col>
      </Row>
    </MainLayout>
  );
};

export default HomeScreen;
